/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableScreensManagerDeps} from '../../../shared/step/repeatable-screen-manager.class';
import {ResidencyService} from '../../../../domain/model/education/residency/residency.service';
import {RepeatableUserModelScreensManager} from '../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';

@Injectable()
export class ResidencyScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: ResidencyService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/residency/residency-screens-manager.service.ts